import { render } from "./BackIcon.vue?vue&type=template&id=6a846fbb&scoped=true"
import script from "./BackIcon.vue?vue&type=script&lang=js"
export * from "./BackIcon.vue?vue&type=script&lang=js"

import "./BackIcon.vue?vue&type=style&index=0&id=6a846fbb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a846fbb"]])

export default __exports__